import { Service } from '@angular/core';
import {EntitySureFlowUnit} from '../model/entity-sure-flow-unit';
import {StringUtils} from '../utils/string-utils';
import {Entity} from '../entity/entity';
import {EntitySureFlowLoop} from '../model/entity-sure-flow-loop';

@Service()
export class SureFlowConfigurationService {

  private readonly ENTITY_NAME_KEY = 'sureflow-entity-name';
  private readonly ENTITY_KEY = 'sureflow-entity';
  private readonly ENTITY_UNITS_KEY = 'sureflow-entity-units';
  private readonly ENTITY_LOOP_KEY = 'entity-sureflow-loop';
  private readonly LAST_RATED_UNIT_KEY = 'sureflow-last-rated-unit';
  private readonly SELECTED_PRODUCT_KEY = 'sureflow-selected-product';

  constructor() {
  }

  clearData(): void {
    sessionStorage.removeItem(this.ENTITY_NAME_KEY);
    sessionStorage.removeItem(this.ENTITY_KEY);
    sessionStorage.removeItem(this.ENTITY_UNITS_KEY);
    sessionStorage.removeItem(this.ENTITY_LOOP_KEY);
    this.clearSelectedProductId();
  }

  getEntityName(): string {
    return sessionStorage.getItem(this.ENTITY_NAME_KEY)!;
  }

  setEntityName(entityName: string): void {
    if (StringUtils.isNotBlank(entityName)) {
      sessionStorage.setItem(this.ENTITY_NAME_KEY, entityName);
    } else {
      sessionStorage.removeItem(this.ENTITY_NAME_KEY);
    }
  }

  getLastRatedUnit(): EntitySureFlowUnit {
    const lastRatedUnit: string = sessionStorage.getItem(this.LAST_RATED_UNIT_KEY)!;
    if (lastRatedUnit) {
      return JSON.parse(lastRatedUnit) as EntitySureFlowUnit;
    } else {
      const newRatedUnit: EntitySureFlowUnit = new EntitySureFlowUnit();
      newRatedUnit.loopId = this.getSelectedEntityLoop()?.id || 0;
      return undefined!;
    }
  }

  setLastRatedUnit(unit: EntitySureFlowUnit): void {
    if (unit) {
      sessionStorage.setItem(this.LAST_RATED_UNIT_KEY, JSON.stringify(unit));
    } else {
      this.clearLastRatedUnit();
    }
  }

  clearLastRatedUnit(): void {
    sessionStorage.removeItem(this.LAST_RATED_UNIT_KEY);
  }

  getSelectedEntityLoop(): EntitySureFlowLoop {
    const loop: string = sessionStorage.getItem(this.ENTITY_LOOP_KEY)!;
    if (loop) {
      return JSON.parse(loop) as EntitySureFlowLoop;
    } else {
      return undefined!;
    }
  }

  setSelectedEntityLoop(loop: EntitySureFlowLoop): void {
    if (loop) {
      sessionStorage.setItem(this.ENTITY_LOOP_KEY, JSON.stringify(loop));
    } else {
      sessionStorage.removeItem(this.ENTITY_LOOP_KEY);
    }
  }

  getSelectedEntity(): Entity {
    const entity: string = sessionStorage.getItem(this.ENTITY_KEY)!;
    if (entity) {
      return JSON.parse(entity) as Entity;
    } else {
      return undefined!;
    }
  }

  setSelectedEntity(entity: Entity): void {
    if (entity) {
      sessionStorage.setItem(this.ENTITY_KEY, JSON.stringify(entity));
    } else {
      sessionStorage.removeItem(this.ENTITY_KEY);
    }
  }

  getSelectedEntityUnits(): EntitySureFlowUnit[] {
    const selectedUnits: string = sessionStorage.getItem(this.ENTITY_UNITS_KEY)!;
    if (selectedUnits) {
      return JSON.parse(selectedUnits) as EntitySureFlowUnit[];
    } else {
      return [];
    }
  }

  setSelectedEntityUnits(units: EntitySureFlowUnit[]) {
    if (units) {
      sessionStorage.setItem(this.ENTITY_UNITS_KEY, JSON.stringify(units));
    } else {
      sessionStorage.removeItem(this.ENTITY_UNITS_KEY);
    }
  }

  getSelectedProductId(): string {
    return sessionStorage.getItem(this.SELECTED_PRODUCT_KEY)!;
  }

  setSelectedProductId(productId: string): void {
    if (StringUtils.isNotBlank(productId)) {
      sessionStorage.setItem(this.SELECTED_PRODUCT_KEY, productId);
    } else {
      this.clearSelectedProductId();
    }
  }

  clearSelectedProductId(): void {
    sessionStorage.removeItem(this.SELECTED_PRODUCT_KEY);
  }

}
